import { PageScroll } from 'app/components/layout/PageScroll'
import { IntegrationsLocationsGroupedComponent } from 'app/components/integrations-locations/IntegrationsLocationsGroupedComponent'
import { useIntegrationsLocations } from 'app/components/integrations-locations/useIntegrationsLocations'

export const handle = {
  title: `Locations`,
  breadcrumb: `Locations`,
}
export type { IntegrationsRow } from 'app/types/integrations'

export default function Locations() {
  const { rows, filters, setSearchValue, onIntegrationClick, isLoading, statusEpoch, syncProgress } =
    useIntegrationsLocations()

  return (
    <PageScroll variant="table">
      <IntegrationsLocationsGroupedComponent
        rows={rows}
        filters={filters}
        setSearchValue={setSearchValue}
        onIntegrationClick={onIntegrationClick}
        isLoading={isLoading}
        statusEpoch={statusEpoch}
        syncProgress={syncProgress}
      />
    </PageScroll>
  )
}
